class ClientServiceMapper {
  static createModelFromResponse(data) {
    if (!data) {
      return undefined;
    }
    return {
      carrierName: data.carrier_name,
      serviceName: data.service_name,
      serviceId: parseInt(data.service_id),
      category: data.service_type,
      dropOff: {
        origin: data.departure_type === 'drop-off',
        destination: data.destination_type === 'drop-off'
      }
    };
  }
}

export { ClientServiceMapper };
//# sourceMappingURL=ClientServiceMapper.js.map
